import React from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LanguageRoute } from "@/i18n";
import Layout from "@/components/site/Layout";
import ScrollToTop from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

function LocalizedShell({ children }) {
  return (
    <LanguageRoute>
      <Layout>{children}</Layout>
    </LanguageRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route
          path="/:lang"
          element={
            <LocalizedShell>
              <Home />
            </LocalizedShell>
          }
        />
        <Route
          path="/:lang/privacy"
          element={
            <LocalizedShell>
              <LegalPage ns="privacy" />
            </LocalizedShell>
          }
        />
        <Route
          path="/:lang/cookies"
          element={
            <LocalizedShell>
              <LegalPage ns="cookies" />
            </LocalizedShell>
          }
        />
        <Route
          path="/:lang/terms"
          element={
            <LocalizedShell>
              <LegalPage ns="terms" />
            </LocalizedShell>
          }
        />
        <Route
          path="*"
          element={
            <LanguageRoute>
              <Layout>
                <NotFound />
              </Layout>
            </LanguageRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
